import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class TemplateFieldApi<TemplateField> extends BaseAPI {
  // constructor() {}

  public getTemplateFields: () => Promise<TemplateField[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/templateField`)).data.output;
  };

  public updateTemplateField: (templateField: TemplateField) => Promise<TemplateField> = async (templateField: TemplateField) => {
    return (await BaseAPI.axios.post(`${baseUrl}/templateField`, templateField)).data.output;
  };

  public getTemplateFieldByName: (fieldName: string) => Promise<TemplateField> = async (fieldName: string) => {
    let result: any = await BaseAPI.axios.get(`${baseUrl}/templateField/${fieldName}`);
    return result.data;
  };
}

export const templateFieldApi = new TemplateFieldApi();
